/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIDataset
 */
export interface AIDataset {
    /**
     * 
     * @type {string}
     * @memberof AIDataset
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AIDataset
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AIDataset
     */
    type?: AIDatasetTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AIDataset
     */
    connection: number;
}

/**
* @export
* @enum {string}
*/
export enum AIDatasetTypeEnum {
    Normal = 'normal',
    FaceLibrary = 'face-library',
    Stt = 'stt'
}

export function AIDatasetFromJSON(json: any): AIDataset {
    return AIDatasetFromJSONTyped(json, false);
}

export function AIDatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIDataset {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'connection': json['connection'],
    };
}

export function AIDatasetToJSON(value?: AIDataset | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
        'connection': value.connection,
    };
}


